import React, { useEffect } from 'react'
import Intro from './Intro'
import HowWeDoIt from './HowWeDoIt'
import Verticals from './Verticals'
import Clients from './Clients'
import School from './School'
import Academy from './Academy'
import Club from './Club'
import Family from './Family'
import Security from './Security'
import Reviews from './Reviews'
import ContactUs from './ContactUs'

// El primer salto a una sección se queda corto: las imágenes de las secciones de
// arriba todavía están cargando y siguen empujando el documento hacia abajo. Se
// repite el salto hasta que la posición se estabiliza, y se abandona en cuanto el
// visitante scrollea por su cuenta para no arrastrarlo de vuelta.
const scrollToSectionWhenSettled = (sectionId) => {
  let timer = null
  let attempts = 0
  let lastPosition = -1

  const scrollToSection = () => {
    const element = document.getElementById(sectionId)

    if (element) {
      element.scrollIntoView({ block: 'start' })
    }
  }

  const stop = () => {
    clearInterval(timer)
    window.removeEventListener('load', scrollToSection)
    window.removeEventListener('wheel', stop)
    window.removeEventListener('touchstart', stop)
    window.removeEventListener('keydown', stop)
  }

  const correct = () => {
    scrollToSection()
    attempts += 1

    if (window.scrollY === lastPosition || attempts >= 8) {
      stop()
      return
    }

    lastPosition = window.scrollY
  }

  scrollToSection()
  lastPosition = window.scrollY
  timer = setInterval(correct, 150)

  window.addEventListener('load', scrollToSection)
  window.addEventListener('wheel', stop, { passive: true })
  window.addEventListener('touchstart', stop, { passive: true })
  window.addEventListener('keydown', stop)

  return stop
}

const Main = ({ scrollTo }) => {

  useEffect(() => {
    if (!scrollTo) {
      window.scrollTo(0, 0)
      return
    }

    return scrollToSectionWhenSettled(scrollTo)
  }, [scrollTo])

  return (
    <>
      <Intro />
      <HowWeDoIt />
      <Verticals />
      <Clients />
      <School />
      <Academy />
      <Club />
      <Family />
      <Security />
      <Reviews />
      <ContactUs />
    </>
  )
}

export default Main